import React from 'react';
import Caret from './Caret';
import './Sort.css';
import { LabelText } from '../../../components/Language';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const Sort = (props) => {
    const title = "Sort";
    const sortTooltip = (
        <Tooltip>
            <LabelText tid="sort" />
        </Tooltip>
    )
   if(!props.order)
    {
    return (   
      <OverlayTrigger placement="right" overlay={sortTooltip} trigger={['hover','click','focus']} delay={{hide:200}}>     
      <div className="order" tabIndex="0" title={title}>
         <div className="dropup" >
        <Caret/>
       </div>      
       <div className="dropdown" >
         <Caret/>
       </div>
      </div>
      </OverlayTrigger> 
     )
     }
   else if(props.order === 'asc') 
    {
    return (
      <OverlayTrigger placement="right" overlay={sortTooltip}>                    
        <div className="order" tabIndex="0" title={title}>        
         <div className="dropup-asc" >
          <Caret/>
         </div>
        </div>
        </OverlayTrigger> )     
    }        
   else if(props.order === 'desc') 
    {
    return (                
      <OverlayTrigger placement="right" overlay={sortTooltip}>
        <div className="order" tabIndex="0" title={title}>        
         <div className="dropdown">
          <Caret/>
         </div>
        </div>
        </OverlayTrigger> )     
    }
   else
    {
     return null;
    }
}

export default Sort;